import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { SharedModule } from "src/app/shared.module";
import { UserNotificationsComponent } from "./user-notifications.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        SharedModule
    ],
    declarations: [UserNotificationsComponent],
    exports: [UserNotificationsComponent]
})
export class UserNotificationsModule {}